import { useEffect } from 'react'

export default function useBeforeUnload({
  showNativePrompt,
}: {
  showNativePrompt: boolean
}): void {
  useEffect(() => {
    const fn = (e: BeforeUnloadEvent) => {
      if (showNativePrompt) {
        e.preventDefault()
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        e.returnValue = ''
      } else {
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        delete e.returnValue
      }
    }
    window.addEventListener('beforeunload', fn)

    return () => {
      window.removeEventListener('beforeunload', fn)
    }
  }, [])
}
